// Layout

const login = () => import('./views/loginPage')

// start Routes
export default [
  {
    path: '',
    name: 'login',
    meta: {
      name: 'login',
      userType: '',
      permission: '',
      breadCrumb: []
    },
    component: login
  }
]
